module.exports = __webpack_public_path__ + "09cb9ccfcb0ee45e441d01e53ca1648a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/saIconWhite.svg
// module id = 43
// module chunks = 0